/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergedUserDelete
 */
export interface MergedUserDelete {
    /**
     * 
     * @type {string}
     * @memberof MergedUserDelete
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof MergedUserDelete
     */
    org_user_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof MergedUserDelete
     */
    user_history_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof MergedUserDelete
     */
    user_private_settings_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof MergedUserDelete
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the MergedUserDelete interface.
 */
export function instanceOfMergedUserDelete(value: object): value is MergedUserDelete {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('org_user_azure_id' in value) || value['org_user_azure_id'] === undefined) return false;
    if (!('user_history_azure_id' in value) || value['user_history_azure_id'] === undefined) return false;
    if (!('user_private_settings_azure_id' in value) || value['user_private_settings_azure_id'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function MergedUserDeleteFromJSON(json: any): MergedUserDelete {
    return MergedUserDeleteFromJSONTyped(json, false);
}

export function MergedUserDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergedUserDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'org_user_azure_id': json['org_user_azure_id'],
        'user_history_azure_id': json['user_history_azure_id'],
        'user_private_settings_azure_id': json['user_private_settings_azure_id'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function MergedUserDeleteToJSON(json: any): MergedUserDelete {
    return MergedUserDeleteToJSONTyped(json, false);
}

export function MergedUserDeleteToJSONTyped(value?: MergedUserDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'org_user_azure_id': value['org_user_azure_id'],
        'user_history_azure_id': value['user_history_azure_id'],
        'user_private_settings_azure_id': value['user_private_settings_azure_id'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

